import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { MenuItem, TextField } from '@mui/material';
import { styled } from '@mui/system';

const StyledTextField = styled(TextField)(({ theme, disabled, customDisabledStyle }) => ({
  minWidth: 120,
  marginTop: 2,
  '& .MuiInput-underline:after': {
    borderBottom: '2px solid rgba(0, 0, 0, 0.42)',
  },
  '& .MuiInputLabel-root': {
    fontSize: 15,
    width: 130,
    color: theme.palette.grey.grey80,
    '&.Mui-focused': {
      color: theme.palette.grey.grey80,
    },
    ...(disabled &&
      customDisabledStyle?.label && {
        color: customDisabledStyle.label,
      }),
  },
  '& .MuiInput-root': {
    ...(disabled &&
      customDisabledStyle?.input && {
        color: customDisabledStyle.input,
      }),
  },
  '& .MuiInput-underline.Mui-disabled:before': {
    ...(customDisabledStyle?.underline && {
      borderBottomColor: customDisabledStyle.underline,
      borderBottomStyle: 'solid',
    }),
  },
}));

function AmbDropdownTimePicker(props) {
  const { times, placeholder, value, onSelect, propsStyles, disabled, disabledPropsStyles, renderValue } = props;

  const handleClick = useCallback(
    event => {
      const { value } = event.target;
      onSelect(value);
    },
    [onSelect],
  );

  return (
    <StyledTextField
      id="select-currency"
      select
      label={placeholder}
      value={value}
      variant="standard"
      onChange={handleClick}
      margin="none"
      style={propsStyles}
      customDisabledStyle={disabledPropsStyles}
      disabled={disabled}
      SelectProps={{
        renderValue: renderValue || (selected => times[selected]),
      }}
    >
      {Object.keys(times).map(time => (
        <MenuItem key={time} value={time} sx={{ '&.MuiMenuItem-root': { padding: '12px 16px' } }}>
          {times[time]}
        </MenuItem>
      ))}
    </StyledTextField>
  );
}

AmbDropdownTimePicker.defaultProps = {
  value: '',
  disabled: false,
};

AmbDropdownTimePicker.propTypes = {
  times: PropTypes.shape({}).isRequired,
  propsStyles: PropTypes.shape({}).isRequired,
  placeholder: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  disabledPropsStyles: PropTypes.shape({
    label: PropTypes.string,
    input: PropTypes.string,
    underline: PropTypes.string,
  }),
  renderValue: PropTypes.func,
};

export default AmbDropdownTimePicker;
